import { Mark } from 'prosemirror-to-html-js';
import get from "lodash/get";

export default class TextStyle extends Mark {
  matching() {
    return this.mark.type === "textStyle";
  }

  tag() {
    const fontSize = get(this.mark, 'attrs.fontSize');
    return [
      {
        tag: "span",
        attrs: fontSize ? {
          style: `font-size: ${fontSize};`
        } : {}
      }
    ];
  }
}
